/**
 * Formats a number with comma separators for thousands
 * Example: 111111111 -> "111,111,111"
 */
export function formatNumberWithCommas(
  value: number | string,
  decimals?: number
): string {
  if (value === '' || value === null || value === undefined) return '';

  // Normalize string input: remove commas and spaces
  const normalized =
    typeof value === 'string'
      ? value.replace(/,/g, '').replace(/\s+/g, '')
      : value;

  const numValue =
    typeof normalized === 'number' ? normalized : Number(normalized);

  if (!Number.isFinite(numValue)) return '';

  if (typeof decimals === 'number') {
    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  return numValue.toLocaleString('en-US');
}
